export default __webpack_public_path__ + "static/media/russia.984ba989.svg";